import { render, staticRenderFns } from "./ReportSurgery.vue?vue&type=template&id=5f6864b3&scoped=true"
import script from "./ReportSurgery.vue?vue&type=script&lang=js"
export * from "./ReportSurgery.vue?vue&type=script&lang=js"
import style0 from "./ReportSurgery.vue?vue&type=style&index=0&id=5f6864b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6864b3",
  null
  
)

export default component.exports